<template>
  <div>

    <div class="field is-horizontal is-block-touch">
      <div class="field-label has-text-left-touch">
        <label class="label">ผู้รับผิดชอบโครงการ</label>
        <p class="help has-text-muted">บุคคลหรือองค์กรที่มีส่วนร่วมภายนอก</p>
      </div>
      <div class="field-body is-block is-flex-widescreen">
        <div class="field is-narrow">
          <table class="table is-narrow is-borderless">
            <tbody>
            <!-- หัวหน้าโครงการ -->
            <tr>
              <td style="width: 450px">
                <v-select class="is-fullwidth"
                          label="full_name"
                          :options="people"
                          :value="this.projectHead.title"
                          @input="(value) => changeMember(this.projectHead, value)"
                          placeholder="ระบุชื่อหัวหน้าโครงการ"
                          :filterable="false"
                          @search="searchPeople"
                          required
                >
                  <p slot="no-options">พิมพ์ชื่อบุคลากร มศว เพื่อค้นหา...</p>
                </v-select>
                <input type="hidden"
                       name="members[0][id]"
                       v-model="this.projectHead.id"
                />
                <input type="hidden"
                       name="members[0][person_id]"
                       v-model="this.projectHead.person_id"
                />
              </td>
              <td>
                {{ position(this.projectHead) }}
                <input type="hidden"
                       name="members[0][is_head]"
                       value="1"
                />
              </td>
              <td>
                <input type="text"
                       class="input"
                       name="members[0][tel]"
                       placeholder="เบอร์ติดต่อ"
                       :value="this.projectHead.tel"
                />
              </td>
            </tr>

            <!-- กรรมการ -->
            <tr v-for="(member, index) in this.members"
                :key="member.created_at">
              <td>
                <v-select class="is-fullwidth"
                          label="full_name"
                          :options="people"
                          :value="member.title"
                          @input="(value) => changeMember(member, value)"
                          placeholder="ระบุชื่อบุุคคลหรือองค์กรที่มีส่วนร่วมภายนอก"
                          taggable
                          :filterable="false"
                          @search="searchPeople"
                >
                  <p slot="no-options">พิมพ์ชื่อบุคลากร มศว เพื่อค้นหา...</p>
                </v-select>
                <input type="hidden"
                       :name="'members[' + (index + 1) + '][id]'"
                       v-model="member.id"
                />
                <input type="hidden"
                       :name="'members[' + (index + 1) + '][title]'"
                       v-model="member.title"
                />
                <input type="hidden"
                       :name="'members[' + (index + 1) + '][person_id]'"
                       v-model="member.person_id"
                />
                <input type="hidden"
                       :name="'members[' + (index + 1) + '][is_staff]'"
                       :value="member.is_staff ? 1: 0"
                />
                <input type="hidden"
                       :name="'members[' + (index + 1) + '][is_secretary]'"
                       :value="member.is_secretary ? 1: 0"
                />
                <input type="hidden"
                       :name="'members[' + (index + 1) + '][is_vice_secretary]'"
                       :value="member.is_vice_secretary ? 1: 0"
                />
              </td>
              <td>
                {{ position(member) }}
              </td>
              <td>
                <div class="delete"
                     :class="!isDeletable(member)? 'is-invisible': ''"
                     @click.prevent="deleteStaff(member, index)"
                ></div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="field">
          <button type="button" class="button is-300"
                  @click.prevent="addStaff"
          >
            เพิ่มกรรมการ
          </button>

          <br/>
          <br/>
          <button type="button" class="button is-300"
                  @click.prevent="addViceSecretary"
          >
            เพิ่มกรรมการและผู้ช่วยเลขานุการ
          </button>

        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
export default {
  data() {
    return {
      people: [],
      newMember
    }
  },
  props: {
    project: {type: Object, required: true},
  },

  computed: {
    projectHead() {
      return this.project.members.find((member) => member.is_head);
    },
    staffs() {
      return this.project.members.filter((member) => member.is_staff);
    },
    secretary() {
      return this.project.members.find((member) => member.is_secretary);
    },
    viceSecretary() {
      return this.project.members.find((member) => member.is_vice_secretary);
    },
    members() {
      return this.project.members.filter((member) => !member.is_head && !member.is_coordinator);
    },
  },
  created() {
    if (!this.projectHead) {
      this.addMember({is_head: true}, 0);
    }

    if (this.staffs.length === 0) {
      this.addMember({is_staff: true}, 1);
    }

    if (!this.secretary) {
      this.addMember({is_secretary: true}, this.staffs.length + 1);
    }

    if (!this.viceSecretary) {
      this.project.members.push(_.extend({}, this.newMember, {is_vice_secretary: true}));
    }

  },
  methods: {
    addStaff() {
      this.addMember({is_staff: true}, this.staffs.length + 1);
    },
    addViceSecretary() {
      this.addMember({is_vice_secretary: true}, this.project.members.length - 1);
    },
    addMember(attributes = {}, start = 0) {
      this.project.members.splice(start, 0, _.extend({created_at: (new Date).getUTCMilliseconds() + Math.random()}, this.newMember, attributes));
      this.$forceUpdate();

    },
    deleteStaff(member, index) {
      if (!this.isDeletable(member)) {
        return;
      }

      this.project.members.splice(index + 1, 1);
      this.$forceUpdate();

    },
    changeMember(member, person) {
      if (member.title == person) {
        return;
      }
      member.person_id = null;

      if (this.isInternalPerson(person)) {
        member.person_id = person.person_id;
      } else {
        member.title = person;
      }

      this.$forceUpdate();
    },

    isInternalPerson(person) {
      return typeof person === 'object' && person != null;
    },

    searchPeople(search, loading) {
      loading(true);

      axios.get('api/people/?q=' + search).then((resp) => {
        this.people = resp.data;
        loading(false);
      });
    },
    position(member) {
      if (member.is_head) return 'หัวหน้าโครงการ';
      if (member.is_staff) return 'กรรมการ';
      if (member.is_secretary) return 'กรรมการและเลขานุการ';
      if (member.is_vice_secretary) return 'กรรมการและผู้ช่วยเลขานุการ';
    },

    isDeletable(member) {
      return member.is_staff || member.is_vice_secretary;
    },
  }
}
</script>
